// extracted by mini-css-extract-plugin
module.exports = {"springBtn":"TimeRange_springBtn__3P1ZX","active":"TimeRange_active__28Zl3"};